import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useUser } from './UserProvider';

const PlatformWebsocketContext = createContext({});
export const usePlatformWebsocket = () => useContext(PlatformWebsocketContext);

const PlatformWebsocketProvider = ({ children }) => {
  const { user, fetchUser } = useUser();
  const [progress, setProgress] = useState({});

  const connectSocket = () => {
    if (!user) return;

    const newSocket = io(process.env.WEBSOCKET_URL);

    newSocket.on("connect", () => {
      console.log('Platform WebSocket Connected');
    });

    newSocket.on("message", (message) => {
      if (process.env.NODE_ENV === 'development') {
        console.log('Platform WebSocket message:', message);
      }
      
      if (message.includes('platform_stats:')) {
        const [_a, platformId, _b, platformProgress] = message.split(':');
        setProgress(prev => ({ ...prev, [platformId]: parseInt(platformProgress) }));
        if (platformProgress === "100") {
          fetchUser();
          newSocket.disconnect();
        }
      }
    });

    newSocket.on("disconnect", () => {
      console.log('Platform WebSocket Disconnected');
    });
  }
  
  const value = {
    progress,
    connectSocket
  };

  return (
    <PlatformWebsocketContext.Provider value={value}>
      {children}
    </PlatformWebsocketContext.Provider>
  );
};

export default PlatformWebsocketProvider; 